//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    address: {
      type: Object,
      default: () => {},
    },
    email: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'billing',
    },
  },
  data() {
    return {
      localAddress: {},
      loading: false,
      success: false,
      successTimeout: null,
    };
  },
  mounted() {
    this.localAddress = { ...this.address };
  },
  methods: {
    save() {
      this.loading = true;
      if (this.successTimeout) {
        clearTimeout(this.successTimeout);
      }
      const data = {
        action: 'vue_save_address',
        type: this.type,
        fields: { ...this.localAddress },
      };
      $.ajax({
        type: 'POST',
        url: wc_add_to_cart_params.ajax_url,
        data,
        success: () => {
          this.loading = false;
          this.success = true;
          this.$emit('update', this.localAddress);
          this.successTimeout = setTimeout(() => {
            this.success = false;
          }, 2000);
        },
        error: ({ responseJSON }) => {
          const { data } = responseJSON;
          const { error } = data;
          console.log(error);
        },
      });
    },
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/auth/partials/Address.vue